import { render, staticRenderFns } from "./singin.vue?vue&type=template&id=5d0f5e8a&scoped=true&"
import script from "./singin.vue?vue&type=script&lang=js&"
export * from "./singin.vue?vue&type=script&lang=js&"
import style0 from "./singin.vue?vue&type=style&index=0&id=5d0f5e8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0f5e8a",
  null
  
)

export default component.exports